import type { FilterFieldsFormContextProviderProps } from './FilterFieldsFormContext.types'
import { FilterFieldsFormContext } from './FilterFieldsFormContext'

export const FilterFieldsFormContextProvider = ({
  value,
  children
}: FilterFieldsFormContextProviderProps) => {
  return (
    <FilterFieldsFormContext.Provider value={value}>
      {children}
    </FilterFieldsFormContext.Provider>
  )
}
